import { Injectable } from '@angular/core';
import { Firestore, doc, docData, getDoc, getDocs, collection, DocumentReference, query, Query, where } from '@angular/fire/firestore';
import { ITableState, ITournamentState, TableType } from '@soposopo/sopo-models';
import { Observable } from 'rxjs';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { FireSubService } from './fireSub.service';
import { Standing } from "@soposopo/sopo-models/dist/tournament/Tournament.state";
import { ApiService } from '../backend/api.service';

@Injectable({
    providedIn: 'root',
})
export class TournamentService {
    constructor(private firestore: Firestore, private fireSubService: FireSubService, private apiService: ApiService) {}

    async getStanding(tournamentId: string, playerId: string) {
        const docReference = doc(this.firestore, `tournaments/${tournamentId}/standings/${playerId}`) as DocumentReference<Standing>;
        const standing = await getDoc(docReference);
        return standing.data()
    }

    getTournament(tID: string, type: string, collectionPath?: string): Promise<any> {
        if (collectionPath === undefined) {
            const docReference = doc(this.firestore, `tournaments/${tID}`);
            return getDoc(docReference)
                .then(async (snapshot) => {
                    const tournamentData = snapshot.data();
                    if (tournamentData == null) {
                        throw new Error(`Tournament data is null`);
                    } else {
                        return tournamentData;
                    }
                });
        }
        const collectionReference = collection(this.firestore, `tournaments/${tID}/${collectionPath}`) as Query<any>;
            return getDocs(collectionReference)
            .then(async (snapshot) => {
                const tournamentData = {};
                snapshot.forEach(async (doc) => {
                    const id = doc.data().id;
                    const tableData = doc.data();
                    tournamentData[id] = tableData;
                });
                if (tournamentData == null) {
                    throw new Error(`Tournament data is null`);
                } else {
                    return tournamentData;
                }
            });
    }

    getTournamentObservable(tournamentId: string): Observable<ITournamentState> {
        const docReference = doc(this.firestore, `tournaments/${tournamentId}`);
        return (docData(docReference) as Observable<ITournamentState>)
        .pipe(
            takeUntil(this.fireSubService.unsubscriber),
            distinctUntilChanged(),
            )
    }

    async getPlayersTable(tournamentId: string, playerId: string): Promise<{id: string | null, playerFound: boolean}> {
        const collectionReference = collection(this.firestore, `tournaments/${tournamentId}/tables`);
        const tableQuery = query(collectionReference, where('seats', 'array-contains', playerId));

        const table = await getDocs(tableQuery).then(data => data.docs.length > 0 ? data.docs[0].data() as unknown as ITableState : undefined);

        if (table) return { id: table.id, playerFound: true};

        const tables = await this.apiService.getTournamentData(tournamentId, TableType.MTT, 'tables');

        if (tables.aggregateDoc.tables.length === 0) return {id: null, playerFound: false};

        const randomTableIndex = Math.floor(Math.random() * tables.aggregateDoc.tables.length);

        return {id: tables.aggregateDoc.tables[randomTableIndex].id, playerFound: false};
    }

}
